import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
import NotificationForm from '../../../components/forms/NotificationForm';
import { NotificationMetrics } from '../../../components/NotificationMetrics';
import Loader from '../../../components/Loader';
import { useFetch } from '../../../hooks/useFetch';

export default function NotificationsShowPage() {
  const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/notifications/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? (
    <>
      <NotificationMetrics notificationId={Number(itemId)} />
      <NotificationForm defaultValues={data?.data} show />
    </>
  ) : (
    <Loader />
  );
}
